import { render, staticRenderFns } from "./orgUserProfile.vue?vue&type=template&id=7abe9a40"
import script from "./orgUserProfile.vue?vue&type=script&lang=js"
export * from "./orgUserProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports